// bernie
import { Store } from 'bernie-plugin-mobx';
import { SerializedData } from 'bernie-core';
import { Logger, NOOP_LOGGER } from 'bernie-logger';

// mobx
import { observable, action, makeObservable } from 'mobx';

// data
import { Program } from 'models';
import { ProgramSource } from '../sources';

export class ProgramStore extends Store {
  public forcedLive;

  constructor(private programSource: ProgramSource, state: SerializedData = {}, logger: Logger = NOOP_LOGGER) {
    super(state, logger);

    makeObservable(this, {
      forcedLive: observable,
      getPrograms: action,
      getProgram: action,
      setForcedLive: action,
    });
  }

  public hydrate(data: SerializedData): void {
    Object.assign(this.programSource, data.programSource);
  }

  public getPrograms(): Program[] {
    return this.programSource.getPrograms();
  }

  public getProgram(programName: string): Program {
    return this.programSource.getProgram(programName);
  }

  public setForcedLive = (program: string): void => {
    this.forcedLive = program;
  };
}
